/** eslint-disable prettier/prettier */
import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal, { SweetAlertOptions } from 'sweetalert2';

@Component({
	selector: 'app-valid-login',
	templateUrl: 'valid-login.component.html',
	styleUrls: ['valid-login.component.scss'],
})
export class ValidLoginComponent implements OnInit {
	constructor(
		private authService: AuthService,
		private router: Router,
		private route: ActivatedRoute,
	) { }

	ngOnInit() {
		this.route.queryParams.subscribe(
			queryParams => {
				const code = queryParams['code'];
				const typeLogin = this.route.snapshot.data.typeLogin;
				if (typeLogin === AuthService.SOEWEB_CALLBACK) {
					this.authService.soewebLogin(code)
						.then((data:any) => {
							if(this.authService.getRedirectTo()) {
								window.location.href = this.authService.getRedirectTo();
							} else {
								window.location.href = data['url'];
							}
						})
						.catch((error: any) => {
							console.log(error);
							Swal.fire({
								title: 'Erro',
								text: error.message ? error.message : error,
								icon: 'error',
								customClass: 'sw-system',
							} as SweetAlertOptions);
							this.router.navigate(['']);
						});
				} else if (typeLogin === AuthService.DROPBOX_CALLBACK) {
					this.authService.dropboxLogin(code)
						.then((data:any) => {
							if(this.authService.getRedirectTo()) {
								window.location.href = this.authService.getRedirectTo();
							} else {
								window.location.href = data['url'];
							}
						})
						.catch((error: any) => {
							console.log(error);
							Swal.fire({
								title: 'Erro',
								text: error.message ? error.message : error,
								icon: 'error',
								customClass: 'sw-system',
							} as SweetAlertOptions);
							this.router.navigate(['']);
						});
				} else if (typeLogin === AuthService.SOEWEB_VINCULAR) {
					this.authService.soewebVincular(code)
						.then((data:any) => {
							Swal.fire({
								title: 'Sucesso',
								text: 'Conta SOEWeb vinculada ao usuário.',
								icon: 'success',
								customClass: 'sw-system',
							} as SweetAlertOptions);
							if(this.authService.getRedirectTo()) {
								this.router.navigate([this.authService.getRedirectTo()]);
							}
						})
						.catch((error: any) => {
							console.log(error);
							Swal.fire({
								title: 'Erro',
								text: error.message ? error.message : error,
								icon: 'error',
								customClass: 'sw-system',
							} as SweetAlertOptions);
							this.router.navigate(['']);
						});
				} else if (typeLogin === AuthService.DROPBOX_VINCULAR) {
					this.authService.dropboxVincular(code)
						.then((data:any) => {
							Swal.fire({
								title: 'Sucesso',
								text: 'Conta Dropbox vinculada ao usuário.',
								icon: 'success',
								customClass: 'sw-system',
							} as SweetAlertOptions);
							if(this.authService.getRedirectTo()) {
								this.router.navigate([this.authService.getRedirectTo()]);
							}
						})
						.catch((error: any) => {
							console.log(error);
							Swal.fire({
								title: 'Erro',
								text: error.message ? error.message : error,
								icon: 'error',
								customClass: 'sw-system',
							} as SweetAlertOptions);
							this.router.navigate(['']);
						});
				}
			},
			error => {
				console.log(error);
				Swal.fire({
					title: 'Erro',
					text: error.message ? error.message : error,
					icon: 'error',
					customClass: 'sw-system',
				} as SweetAlertOptions);
				this.router.navigate(['']);
			}
		);
	}
}
